$(document).ready(function () {
    $('#acronym').on('input', (e) => {
        e.target.value = e.target.value.toUpperCase();
    });

    let current_budget = parseFloat($('#current_budget').val());
    let total_budget = parseFloat($('#total_budget').val());
    $('#total_budget').on('input', (e) => toggleCurrentBudget(e, current_budget, total_budget));
});

function toggleCurrentBudget(e, current_budget, total_budget) {
    if (e.target.value)
    {
        let diff = parseFloat(e.target.value) - total_budget;
        $('#current_budget').val((current_budget + diff).toFixed(5));
    }
    else
        $('#current_budget').val(current_budget);
}